<template>
	<div class="scroll">
		<div :class=" scroll? 'scroll-y':'scroll-x'" ref="scrollview">
			<div style="display: inline-block;white-space: nowrap;" v-if="!scroll"><slot></slot></div>
			<div v-else><slot></slot></div>
		</div>
	</div>
</template>
<script>
export default {
  props: {
    scroll: { // 默认横向滚动，，true为纵向滚动
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  mounted() {
    this.$refs.scrollview.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const { scrollTop } = this.$refs.scrollview;
      const { scrollLeft } = this.$refs.scrollview;
      const { offsetHeight } = this.$refs.scrollview;
      const num = Number(scrollTop + offsetHeight + 1).toFixed(2);

      if (num > this.$refs.scrollview.scrollHeight) {
        this.$emit('bindscrolltolower');
      }

      this.$emit('bindscroll', { top: scrollTop, left: scrollLeft });
    },
  },
};
</script>

<style lang="less">
	.scroll {
		width: 100%;
		height: 100%;
		overflow: hidden;

		.scroll-x {
			width: 100%;
			height: 100%;
			overflow-x: auto;
		}

		.scroll-y {
			width: 100%;
			height: 100%;
			overflow-y: auto;
		}
	}

</style>
